import axios from "../lib/axios";

export const createGallery = async (data) => {
  try {
    const response = await axios.post("/gallery/add", data);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create gallery"
    );
  }
};

export const getGalleryById = async (galleryId) => {
  if (!galleryId) {
    throw new Error("Gallery ID is required");
  }

  try {
    const response = await axios.get(`/gallery/gallery-details/${galleryId}`);
    return response.data?.data || response.data;
  } catch (error) {
    const message = error?.response?.data?.message || "Failed to fetch gallery";
    throw new Error(message);
  }
};

export const getAllGalleries = async (lastId, limit = 10, status = "") => {
  try {
    const params = new URLSearchParams();
    if (lastId) params.append("lastId", lastId);
    params.append("limit", limit.toString());
    if (status) params.append("status", status);

    const url = `/gallery/all?${params.toString()}`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to fetch galleries"
    );
  }
};

export const updateGalleryStatus = async ({ galleryId, action }) => {
  try {
    const response = await axios.put("/gallery/update", {
      galleryId,
      action,
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to update gallery"
    );
  }
};

export const updateGalleryData = async ({ galleryId, payload }) => {
  try {
    const response = await axios.put("/gallery/update-data", {
      galleryId,
      payload,
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to update gallery"
    );
  }
};
